
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/New-home-design",
      function () {
        return require("private-next-pages/New-home-design.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/New-home-design"])
      });
    }
  